import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { Paperclip } from 'lucide-react';
import { useDragHandlersRef } from './chat-input-context';
interface DragOverlayProps {
  className?: string;
}

/**
 * Drag overlay component that shows when files are being dragged over the input.
 * Reads drag state from drag handlers ref (populated by ChatAttachments if rendered).
 */
export function DragOverlay(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const handlersRef = useDragHandlersRef();
  const isDragging = handlersRef.current.isDragging ?? false;
  let t1;
  if ($[0] !== className || $[1] !== isDragging) {
    t1 = isDragging && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className={`border-rebrand-400 bg-background/70 absolute inset-0 z-50 flex items-center justify-center gap-3 rounded-lg border border-dashed p-4 ${className || ""}`}><Paperclip size={24} /><div className="flex flex-col gap-1"><p className="text-base font-medium">Drop files here to attach</p><p className="text-muted-foreground text-sm">Supports PDF and images</p></div></motion.div>;
    $[0] = className;
    $[1] = isDragging;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}